// frontend/src/services/marketplace/fetchMarketplaceListings.js
import { supabase } from "../../supabaseClient";
import normalizeMarketplaceListing from "./normalizeMarketplaceListing";

export async function fetchMarketplaceListings({ offset = 0, limit = null } = {}) {
  let query = supabase.rpc("get_public_marketplace_listings");

  if (Number.isInteger(limit) && limit > 0) {
    query = query.range(offset, offset + limit - 1);
  }

  const { data, error } = await query;

  if (error) {
    throw error;
  }

  return (data || [])
    .map(normalizeMarketplaceListing)
    .filter(Boolean);
}

export async function fetchMarketplaceListingById(listingId) {
  if (!listingId) return null;

  const { data, error } = await supabase
    .rpc("get_public_marketplace_listings")
    .eq("listing_id", listingId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return normalizeMarketplaceListing(data);
}

export default fetchMarketplaceListings;
